import clsx from 'clsx'
import React, {useState} from 'react'
import queryString from 'query-string'
import {useHistory} from 'react-router-dom'
import SearchIcon from '@mui/icons-material/Search'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import InputAdornment from '@mui/material/InputAdornment'
import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    backgroundColor: '#fff',
    border: 'solid 1px #bec4d2',
    borderRadius: '5px',
    width: '100%'
  },
  input: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    "& > input": {
      flexGrow: 1,
      padding: '8px 0 7px 5px',
      fontSize: "12pt",
      color: "#747b95",
      border: 'none',
      '&:focus': {
        outline: 'none'
      }
    }
  },
  icon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0px 6px',
    "& svg": {
      fontWeight: "bold",
      color: "#747b95",
    }
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '8px 10px',
    borderLeft: '1px solid #bec4d2',
    color: "#747b95",
    cursor: 'pointer',
    "&:hover": {
      backgroundColor: '#2ca5ec',
      color: '#fff'
    }
  }
}))

export default function SearchPattern ({className, path, placeholder, context}) {

  const [pattern, setPattern] = useState(context.query.pattern || '')
  const classes = useStyles()
  const history = useHistory()

  function searchPattern() {
    const query = {...context.query, page: 1, pattern: pattern == '' ? undefined : pattern }
    if (path != history.location.pathname)
      context.setState({searchBackPath: history.location.pathname})
    history.push(context.link(undefined, undefined, {query}))
  }

  React.useEffect(() => {
    setPattern(context.query.pattern || '')
  }, [context.query.pattern])

  return (
    <div className={clsx(className, classes.root)}>
      <Grid container wrap='nowrap'>
        <Grid item className={classes.icon}>
          <SearchIcon />
        </Grid>
        <Grid item className={classes.input}>
          <input
            onChange={e => setPattern(e.target.value)}
            value={pattern}
            placeholder={placeholder}
            onKeyPress = {({key}) => key == 'Enter' && searchPattern()}
          />
        </Grid>
        <Grid item className={classes.label} onClick={searchPattern}>
          {context.translate('go_label')}
        </Grid>
      </Grid>
    </div>
  )
}
